import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/useReducedMotion";

// A hand-drawn mountain ridgeline as an inline SVG polyline.
// Signature ROAM motif — section dividers, footer horizon, loader.
const PROFILES = {
  a: "0,150 60,128 130,140 180,150 250,118 340,44 400,108 470,72 560,124 650,150 700,96 800,22 900,110 1000,64 1090,120 1190,52 1290,104 1370,132 1440,150",
  b: "0,138 90,120 170,130 260,104 350,124 450,86 540,116 650,66 740,110 850,92 960,60 1070,112 1180,80 1290,118 1370,100 1440,124",
};

export const Ridgeline = ({
  className = "",
  stroke = "#C89A4E",
  strokeWidth = 1.5,
  variant = "a",
  animate = false,
  height = 160,
}) => {
  const reduced = usePrefersReducedMotion();
  const points = PROFILES[variant] || PROFILES.a;

  return (
    <svg
      className={className}
      viewBox="0 0 1440 160"
      width="100%"
      height={height}
      preserveAspectRatio="none"
      fill="none"
      aria-hidden="true"
      data-testid="ridgeline-svg"
    >
      {animate && !reduced ? (
        <motion.polyline
          points={points}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
        />
      ) : (
        <polyline
          points={points}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      )}
    </svg>
  );
};

export default Ridgeline;
